/**
 * Available roles for currently known modules
 * DCV => datachain viewer AKA datachain marketplace
 * DCC => datachain console
 * DC  => datachain core
 * DCM => datachain maestro
 */
export enum RoleModel {
	DCV_MEMBER = 'DCV_MEMBER',
	DCV_ADMIN = 'DCV_ADMIN',

	DCC_MEMBER = 'DCC_MEMBER',
	DCC_ADMIN = 'DCC_ADMIN',
	DCC_ORGANIZATION_ADMIN = 'DCC_ORGANIZATION_ADMIN',

	DC_MEMBER = 'DC_MEMBER',
	DC_PROJECT = 'DC_PROJECT',
	DC_ADMIN = 'DC_ADMIN',
	DC_CONSO = 'DC_CONSO',
}
